import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { Socket } from 'ngx-socket-io';
import { catchError, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment.production';
import { Md5 } from 'ts-md5';
import { PickupService } from './pickup.service';
import { UtilitiesService } from './utilities.service';
import { Pedido } from '../interfaces/Pedido';
import packagejson from '../../../package.json';
import { lastValueFrom } from 'rxjs';

export interface ColaBineo {
  isChecked?: boolean;
  id: string;
  sg123: string;
  ubicacion: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class QueueService {
  public appVersion: string = packagejson.version;
  interval_update_pedidos: any;
  interval_cola: any;
  lugar_entrega: string = '';
  lock: boolean = true;

  LOOP_INTERVAL = 10 * 1000;

  last_queue_process_time: any = '';
  public current_firma: any[] = [];
  public current_bineo: Map<string, ColaBineo[]> = new Map();

  constructor(
    public http: HttpClient,
    public socket: Socket,
    private provService: PickupService,
    private utilityService: UtilitiesService
  ) {}

  async queueHandler() {
    console.log('Se ha iniciado el servicio de envió de datos por cola');
    const colaFirma = await this.utilityService.getObject('cola_firma');
    const colaImagen = await this.utilityService.getObject('cola_imagen');

    const colaBineo = await this.utilityService.getObject('cola_bineo');

    if (!colaFirma) await this.utilityService.setObject('cola_firma', []);
    if (!colaImagen) await this.utilityService.setObject('cola_imagen', []);

    if (!colaBineo) await this.utilityService.setObject('cola_bineo', []);

    this.interval_update_pedidos = setInterval(() => {
      this.provService.actualizarTiempoEspera();
      this.provService.actualizarLlegadaEstimada();
    }, 1000);
    await this.setPedidosEnCola();
    await this.startQueueHandler();

    setTimeout(() => {
      this.lock = false;
    }, 20 * 1000);
  }

  async startQueueHandler(): Promise<any> {
    if (!this.lock) this.lock = true;
    else return setTimeout(() => this.startQueueHandler(), this.LOOP_INTERVAL);

    await Promise.all([
      this.procesarCola(),
      this.procesarColaFoto(),
      this.procesarColaBineo(),
    ]);
    await this.setPedidosEnCola();

    this.lock = false;

    setTimeout(() => this.startQueueHandler(), this.LOOP_INTERVAL);
  }

  async agregarColaLoop(pedidoActivo: Pedido) {
    if (this.lock)
      return setTimeout(() => {
        this.agregarColaLoop(pedidoActivo);
      }, 300);

    this.agregarCola(pedidoActivo);
  }

  async agregarColaBineoLoop(bineo: ColaBineo[]) {
    if (this.lock)
      return setTimeout(() => {
        this.agregarColaBineoLoop(bineo);
      }, 300);

    this.agregarColaBineo(bineo);
  }

  async agregarColaBineo(bineo: ColaBineo[]) {
    if (!bineo.length) return;
    const storedData = await this.utilityService.getObject('cola_bineo');
    const parsedData = Array.isArray(JSON.parse(storedData || '[]'))
      ? JSON.parse(storedData || '[]')
      : [];
    const cola_bineo = new Map<string, ColaBineo[]>(parsedData);

    const sg123 = bineo[0].sg123;
    const existingBineo: ColaBineo[] = cola_bineo.get(sg123) || [];

    const bineoMap = new Map(bineo.map((item) => [item.id, item]));

    const processedIds = new Set<string>();

    const updatedBineo = existingBineo.map((item) => {
      const update = bineoMap.get(item.id);
      if (update) {
        processedIds.add(item.id);
        if (update.isChecked) return { ...item, ...update };

        return {
          ...item,
          ubicacion: update.ubicacion,
          isChecked: update.isChecked,
        };
      }
      return item;
    });

    const newItems = bineo.filter((item) => !processedIds.has(item.id));

    cola_bineo.set(sg123, [...updatedBineo, ...newItems]);

    await this.utilityService.setObject(
      'cola_bineo',
      Array.from(cola_bineo.entries())
    );
  }

  async agregarCola(pedidoActivo: Pedido) {
    let cola_firma = JSON.parse(
      await this.utilityService.getObject('cola_firma')
    );
    let cola_imagen = JSON.parse(
      await this.utilityService.getObject('cola_imagen')
    );

    cola_firma = Array.isArray(cola_firma) ? cola_firma : [];
    cola_imagen = Array.isArray(cola_imagen) ? cola_imagen : [];

    let params = {
      orden: pedidoActivo.orden,
      sg123: pedidoActivo.sg123,
      imagen_firma: pedidoActivo.imagen_firma,
      fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
      fecha_runner: moment().format('YYYY-MM-DD HH:mm:ss'),
      evidencia_entrega: pedidoActivo.evidencia_entrega,
      rut_retira: pedidoActivo.rut_retira,
      patente_retira: pedidoActivo.patente_retira,
      tipo_entrega: pedidoActivo.tipo_entrega,
      lugar_entrega: pedidoActivo.lugar_entrega,
      version: this.appVersion,
    };

    console.log('params', params);

    cola_firma.push(params);
    if (pedidoActivo.imagen_firma) cola_imagen.push(params);
    // });

    // this.provService.cola_firma.splice(0, shallow_firma.length);

    try {
      await this.utilityService.setObject('cola_firma', cola_firma);
      await this.utilityService.setObject('cola_imagen', cola_imagen);

      pedidoActivo.loader_entrega = 'exito';
    } catch (error) {
      console.error(error);
      pedidoActivo.loader_entrega = 'error';
    }
    // }
  }

  //BINEO
  async procesarColaBineo() {
    const storedData = await this.utilityService.getObject('cola_bineo');
    const parsedData = Array.isArray(JSON.parse(storedData || '[]'))
      ? JSON.parse(storedData || '[]')
      : [];
    const queueBineo = new Map<string, ColaBineo[]>(parsedData);

    if (!queueBineo.size) return;
    const sg123 = queueBineo.keys().next().value;
    if (!sg123) return;

    const bineoData = queueBineo.get(sg123) || [];
    if (!bineoData.length) return;

    try {
      const response = await lastValueFrom<any>(
        this.http
          .post(environment.api_host + '/api/bultos-actualizar-ubicaciones', {
            bultos: bineoData,
          })
          .pipe(
            timeout(this.LOOP_INTERVAL),
            catchError(async (_) => {
              throw Error('TimeOut');
            })
          )
      );

      if (response.success) {
        queueBineo.delete(sg123);
        await this.utilityService.setObject(
          'cola_bineo',
          Array.from(queueBineo.entries())
        );
        if (this.provService.pedidoActivo.sg123 === sg123) {
          this.provService.pedidoActivo.bultos.forEach((bulto) => {
            bulto.enCola = false;
          });
        }
      } else {
        if (response.bultos_actualizados.length) {
          const successSet = new Set([...response.bultos_actualizados]);
          queueBineo.set(
            sg123,
            bineoData.filter((b) => !successSet.has(b.id))
          );
          await this.utilityService.setObject(
            'cola_bineo',
            Array.from(queueBineo.entries())
          );
          if (this.provService.pedidoActivo.sg123 === sg123) {
            this.provService.pedidoActivo.bultos.forEach((bulto) => {
              if (successSet.has(bulto.id)) {
                bulto.enCola = false;
              }
            });
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  //ORDEN

  async procesarCola() {
    let fecha_disp = moment().format('YYYY-MM-DD HH:mm:ss');

    let queue_firma = JSON.parse(
      await this.utilityService.getObject('cola_firma')
    );

    if (queue_firma && queue_firma.length) {
      let firma = queue_firma[0];

      let httpParams = new HttpParams()
        .append('runner_id', this.provService.usuario.id.toString())
        .append('orden', firma.sg123)
        .append('fecha', firma.fecha)
        .append('fecha_runner', firma.fecha_runner)
        .append('fecha_disp', fecha_disp)
        .append('evidencia_entrega', firma.evidencia_entrega)
        .append('rut_retira', firma.rut_retira)
        .append('patente_retira', firma.patente_retira)
        .append('tipo_entrega', firma.tipo_entrega)
        .append('lugar_entrega', firma.lugar_entrega)
        .append('version_app', firma.version);

      try {
        await this.http
          .post(
            environment.api_host + '/api/firmar-entrega-app-socket',
            httpParams
          )
          .pipe(
            timeout(this.LOOP_INTERVAL),
            catchError(async (_) => {
              throw Error('TimeOut');
            })
          )
          .toPromise();

        queue_firma.shift();
        await this.utilityService.setObject('cola_firma', queue_firma);
      } catch (error) {
        console.error(error);
        this.last_queue_process_time = this.utilityService.getCurrentTime();
      }
    }
  }

  //FOTO

  async procesarColaFoto() {
    let md5 = new Md5();
    let queue_imagen =
      JSON.parse(await this.utilityService.getObject('cola_imagen')) ?? [];

    if (queue_imagen.length) {
      let imagen = queue_imagen[0];

      let httpParamsImagen = new HttpParams()
        .append('orden', imagen.sg123)
        .append('imagen_firma', imagen.imagen_firma)
        .append('lugar_entrega', this.lugar_entrega);

      let encrypted_64base = md5
        .appendStr(imagen.imagen_firma)
        .end()
        ?.toString();

      try {
        let raw_data = await this.http
          .post(
            environment.api_host + '/api/firmar-entrega-app-socket-imagen',
            httpParamsImagen
          )
          .pipe(
            timeout(this.LOOP_INTERVAL),
            catchError(async (_) => {
              throw Error('TimeOut');
            })
          )
          .toPromise();

        if (raw_data == encrypted_64base) {
          queue_imagen.shift();
          await this.utilityService.setObject('cola_imagen', queue_imagen);
        } else {
          console.error(
            'Posible error al enviar la foto. Los MD5 no coinciden'
          );
        }
      } catch (error) {
        console.error(error);
        this.last_queue_process_time = this.utilityService.getCurrentTime();
      }
    }
  }

  async setPedidosEnCola() {
    const [queue_firma, queue_imagen, queue_bineo] = await Promise.all([
      this.utilityService
        .getObject('cola_firma')
        .then((data) => JSON.parse(data) ?? []),
      this.utilityService
        .getObject('cola_imagen')
        .then((data) => JSON.parse(data) ?? []),
      this.utilityService
        .getObject('cola_bineo')
        .then((data) => JSON.parse(data) ?? []),
    ]);
    const firmaArray = Array.isArray(queue_firma) ? queue_firma : [];
    const imagenArray = Array.isArray(queue_imagen) ? queue_imagen : [];
    const bineoMap: Map<string, ColaBineo[]> = Array.isArray(queue_bineo)
      ? new Map(queue_bineo)
      : new Map();

    const firmaOrderSet = new Set(
      firmaArray.map((pedido: any) => pedido.orden)
    );
    const imagenOrderSet = new Set(imagenArray.map((img: any) => img.orden));

    const processedFirma = firmaArray.map((pedido: any) => ({
      ...pedido,
      check: {
        firma: true,
        imagen: imagenOrderSet.has(pedido.orden),
      },
    }));

    const imagenOnlyEntries = imagenArray
      .filter((img: any) => !firmaOrderSet.has(img.orden))
      .map((img: any) => ({
        ...img,
        check: {
          firma: false,
          imagen: true,
        },
      }));

    this.current_firma = [...processedFirma, ...imagenOnlyEntries];
    this.current_bineo = bineoMap;
  }
}
